import React, { Component } from 'react';
import { Field } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';

import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';

import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import * as validator from 'helpers/Validator';

import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

class EmergencyContactsFieldArrayOutlined extends Component {
  render() {
    const { fields } = this.props;

    return (
      <div className="row">
        <CSSTransitionGroup
          transitionName="emergency_contact_new_mui"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {fields.map((emergencyContact, index) => (
            <div key={index} className="row">
              <div className="cotenantHeader" style={{ padding: '0 15px', marginBottom: '-10px' }}>
                <h4 style={{ lineHeight: '26px' }}>
                  Emergency Contact #{index + 1}
                  {this._renderDeleteButton(fields, index, this.props.startDeletingAtIndex)}
                </h4>
              </div>

              <div className="row" style={{ marginBottom: '0px' }}>
                <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Field
                    name={`${emergencyContact}.full_name`}
                    type="text"
                    component={TextField}
                    label="Full Name"
                    validate={[validator.required, validator.fullName]}
                    variant="outlined"
                  />
                </div>
                <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Field
                    name={`${emergencyContact}.email`}
                    type="text"
                    component={TextField}
                    label="Email"
                    validate={[validator.validEmail]}
                    variant="outlined"
                  />
                </div>
              </div>
              <div className="row" style={{ marginBottom: '0px' }}>
                <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Field
                    name={`${emergencyContact}.phone_number`}
                    type="text"
                    component={ReactPhoneInput}
                    label="Phone Number"
                    validate={[validator.required, validator.validInternationalPhoneNumber]}
                    variant="outlined"
                  />
                </div>
                <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                  {featureEnabled('ui.yardi_emergency_contacts_page.relationships') ? (
                    <Field
                      name={`${emergencyContact}.relationship`}
                      component={OutlinedSelect}
                      label={getTranslatedString(
                        'landlordPortal.emergencyContactsFieldArray.relationshipType'
                      )}
                      errorStyle={{ fontSize: '14px' }}
                      validate={[validator.required]}
                    >
                      <MenuItem value={'Daughter'}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsYardiRelationships.daughter'
                        )}
                      </MenuItem>
                      <MenuItem value={'Friend'}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsYardiRelationships.friend'
                        )}
                      </MenuItem>
                      <MenuItem value={'Husband'}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsYardiRelationships.husband'
                        )}
                      </MenuItem>
                      <MenuItem value={'Son'}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsYardiRelationships.son'
                        )}
                      </MenuItem>
                      <MenuItem value={'Wife'}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsYardiRelationships.wife'
                        )}
                      </MenuItem>
                      <MenuItem value={'Other'}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsYardiRelationships.other'
                        )}
                      </MenuItem>
                    </Field>
                  ) : (
                    <Field
                      name={`${emergencyContact}.relationship`}
                      component={OutlinedSelect}
                      label={getTranslatedString(
                        'landlordPortal.emergencyContactsFieldArray.relationshipType'
                      )}
                      errorStyle={{ fontSize: '14px' }}
                      validate={[validator.required]}
                    >
                      <MenuItem value="Family">
                        {getTranslatedString('landlordPortal.emergencyContactsFieldArray.family')}
                      </MenuItem>
                      <MenuItem value="Friend">
                        {getTranslatedString('landlordPortal.emergencyContactsFieldArray.friend')}
                      </MenuItem>
                      <MenuItem value="Significant Other">
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsFieldArray.significantOther'
                        )}
                      </MenuItem>
                      <MenuItem value="Work Associate">
                        {getTranslatedString(
                          'landlordPortal.emergencyContactsFieldArray.workAssociate'
                        )}
                      </MenuItem>
                    </Field>
                  )}
                </div>
              </div>
            </div>
          ))}
        </CSSTransitionGroup>
        <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
          <FlatButton
            label="Add Emergency Contact"
            type="button"
            backgroundColor={AccentColor()}
            hoverColor="grey"
            style={{ color: 'white' }}
            onClick={() => {
              fields.push({});
              setTimeout(() => {
                const button = document.getElementById('button');
                if (button) button.scrollIntoView({ block: 'end', behaviour: 'smooth' });
              }, 0);
            }}
          />
        </div>
      </div>
    );
  }

  _renderDeleteButton = (fields, index, startDeletingAtIndex = 0) => {
    if (index >= startDeletingAtIndex) {
      return (
        <IconButton
          style={{
            padding: 0,
            verticalAlign: 'text-bottom',
            width: 'none',
            height: 'none',
            float: 'right',
          }}
          onClick={() => {
            fields.remove(index);
          }}
        >
          <DeleteIcon size={24} style={{ padding: 0 }} />
        </IconButton>
      );
    }
  };
}

export default EmergencyContactsFieldArrayOutlined;
